import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import redirects_45global from "/app/middleware/redirects.global.ts";
import utm_45global from "/app/middleware/utm.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  redirects_45global,
  utm_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}